var map = {
	"./account.svg": "ecec",
	"./answer.svg": "1269",
	"./catalogue.svg": "1f07",
	"./delete.svg": "0d45",
	"./email.svg": "43be",
	"./error.svg": "28c3",
	"./exit-fullscreen.svg": "62d5",
	"./forward.svg": "bdb1",
	"./fullscreen.svg": "379e",
	"./help.svg": "acc2",
	"./hide.svg": "a010",
	"./home.svg": "ac9d",
	"./home2.svg": "3b93",
	"./huifu.svg": "2cac",
	"./image.svg": "931c",
	"./lecture.svg": "96ca",
	"./mobile.svg": "0df4",
	"./mobile2.svg": "68e0",
	"./mute.svg": "11df",
	"./next.svg": "0043",
	"./notes.svg": "8190",
	"./password.svg": "b009",
	"./pause.svg": "644b",
	"./pip.svg": "3143",
	"./play.svg": "dab1",
	"./prev.svg": "ed83",
	"./replay.svg": "bdf0",
	"./setting.svg": "5de8",
	"./show.svg": "b65e",
	"./volume-1.svg": "16a4",
	"./volume-2.svg": "dcea",
	"./volume-mute.svg": "6a7b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a244";